import React from 'react';
import { Filter, X } from 'lucide-react';
import type { DashboardFilters } from '../../types/analytics';

interface Props {
  filters: DashboardFilters;
  onChange: (filters: DashboardFilters) => void;
  onReset: () => void;
  isOpen: boolean;
  onToggle: () => void;
}

export default function FilterPanel({ filters, onChange, onReset, isOpen, onToggle }: Props) {
  const categories = [
    { value: 'all', label: 'All Categories' },
    { value: 'wedding', label: 'Wedding' },
    { value: 'baby', label: 'Baby Shower' },
    { value: 'birthday', label: 'Birthday' },
    { value: 'holiday', label: 'Holiday' },
    { value: 'housewarming', label: 'Housewarming' }
  ];

  const userSegments = [
    { value: 'all', label: 'All Users' },
    { value: 'new', label: 'New Users' },
    { value: 'returning', label: 'Returning Users' },
    { value: 'power', label: 'Power Users' }
  ];

  const regions = [
    { value: 'all', label: 'All Regions' },
    { value: 'sri-lanka', label: 'Sri Lanka' },
    { value: 'india', label: 'India' },
    { value: 'usa', label: 'United States' },
    { value: 'uk', label: 'United Kingdom' },
    { value: 'australia', label: 'Australia' }
  ];

  if (!isOpen) {
    return (
      <button
        onClick={onToggle}
        className="flex items-center space-x-2 px-4 py-2 bg-gray-800/50 border border-gray-700 text-white rounded-md hover:bg-gray-700/50 transition-colors"
      >
        <Filter className="w-4 h-4" />
        <span>Filters</span>
      </button>
    );
  }

  return (
    <div className="bg-gray-800/50 backdrop-blur-xl border border-white/20 rounded-3xl shadow-soft-lg p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Filter className="w-4 h-4 text-white" />
          <h3 className="font-medium text-white">Filters</h3>
        </div>
        <button
          onClick={onToggle}
          className="p-1 hover:bg-gray-700 rounded-full transition-colors text-gray-400 hover:text-white"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Category
          </label>
          <select
            value={filters.category}
            onChange={(e) => onChange({ ...filters, category: e.target.value })}
            className="w-full px-3 py-2 bg-gray-900/50 border border-gray-700 text-white rounded-md focus:ring-primary focus:border-primary"
          >
            {categories.map((category) => (
              <option key={category.value} value={category.value}>
                {category.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            User Segment
          </label>
          <select
            value={filters.userSegment}
            onChange={(e) => onChange({ ...filters, userSegment: e.target.value })}
            className="w-full px-3 py-2 bg-gray-900/50 border border-gray-700 text-white rounded-md focus:ring-primary focus:border-primary"
          >
            {userSegments.map((segment) => (
              <option key={segment.value} value={segment.value}>
                {segment.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Region
          </label>
          <select
            value={filters.region}
            onChange={(e) => onChange({ ...filters, region: e.target.value })}
            className="w-full px-3 py-2 bg-gray-900/50 border border-gray-700 text-white rounded-md focus:ring-primary focus:border-primary"
          >
            {regions.map((region) => (
              <option key={region.value} value={region.value}>
                {region.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="flex justify-end space-x-2 mt-4">
        <button
          onClick={onReset}
          className="px-4 py-2 text-sm text-gray-300 hover:text-white border border-gray-600 rounded-md hover:bg-gray-700/50 transition-colors"
        >
          Reset
        </button>
        <button
          onClick={onToggle}
          className="px-4 py-2 text-sm bg-primary text-white rounded-md hover:bg-primary-600 transition-colors"
        >
          Apply Filters
        </button>
      </div>
    </div>
  );
}